import { useContext, useLayoutEffect, useEffect } from 'haunted/lib/core';

import { AccordionContext } from '../accordion/accordion.context';
import { component } from '../../utils';

function AccordionSlide(el: HTMLElement): null {
  const context = useContext(AccordionContext);

  useEffect(() => {
    if (el.dataset.captureClick === undefined) {
      return;
    }

    const clickHandler = (e: Event) => {
      e.stopPropagation();
    };

    el.addEventListener('click', clickHandler);
    return () => {
      el.removeEventListener('click', clickHandler);
    };
  }, [el]);

  useLayoutEffect(() => {
    let state = 'initial';

    if (!context) {
      el.dataset.state = state;
      return;
    }

    const { openIndexes } = context;
    const { slideId } = el.dataset;

    if (openIndexes.indexOf(slideId) === -1) {
      state = 'closed';
    } else {
      state = 'active';
    }

    el.dataset.state = state;
  }, [context, el.dataset]);

  return null;
}

export const AccordionSlideElement = component(AccordionSlide, {
  useShadowDOM: false,
});
